import { createFileRoute } from "@tanstack/react-router";
import AetnaInsurance, { config } from "@/pages/AetnaInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/aetna-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Aetna TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Have Aetna insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Aetna plan in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Aetna TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Have Aetna insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Aetna plan in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/aetna-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/aetna-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AetnaInsurance />;
}
